/**
 * The documents ladder, lowest first: each level confers the ones below it. The order is load-bearing: the role
 * editor lists it as is, and the highest-first list below ranks what a role holds.
 */
export const DOCUMENT_ACCESS_LEVELS = ['none', 'view', 'edit', 'full'] as const

export type DocumentAccessLevel = (typeof DOCUMENT_ACCESS_LEVELS)[number]

export type GrantedDocumentAccessLevel = Exclude<DocumentAccessLevel, 'none'>

/** The levels a role or set can hold, highest first: the first one held is the effective level. */
export const GRANTED_DOCUMENT_ACCESS_LEVELS_HIGHEST_FIRST = [
  'full',
  'edit',
  'view',
] as const satisfies readonly GrantedDocumentAccessLevel[]
